import Link from './src/Link';

export * from './src/Link';
export default Link;
